import React, {useEffect, useState} from 'react';
import style from './style.module.scss'; // won't generate a '.d.ts' file until component is included in the app
import {IProps, IHandlers} from './types';
import {Checkbox, FormControlLabel, withStyles} from '@material-ui/core';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import AppThemeService from "app/services/theme/appTheme.service";

const NS = 'EventBlockout';

export default function EventBlockout({handleChange, _staffRequiredCreateBlockout, _staffRequiredCreateEvent, _staffRequiredEditEvent,
  _staffRequiredEditBlockout, isLoading} : IProps & IHandlers) {

    const [staffRequiredCreateBlockout, setStaffRequiredCreateBlockout] = useState<boolean>(false);
    const [staffRequiredCreateEvent, setStaffRequiredCreateEvent] = useState<boolean>(false);
    const [staffRequiredEditEvent, setStaffRequiredEditEvent] = useState<boolean>(false);
    const [staffRequiredEditBlockout, setStaffRequiredEditBlockout] = useState<boolean>(false);

  useEffect (() => {
    setStaffRequiredCreateBlockout(_staffRequiredCreateBlockout);
    setStaffRequiredCreateEvent(_staffRequiredCreateEvent);
    setStaffRequiredEditEvent(_staffRequiredEditEvent);
    setStaffRequiredEditBlockout(_staffRequiredEditBlockout);
  }, [isLoading]);

  const theme = AppThemeService.getAppTheme();

  const CheckBoxCustom = withStyles({
    root: {
      color: '#757575', // rgb(117, 117, 117)
      transform: 'scale(1.07)'
    },
  })(Checkbox);

  const CheckBoxIconCustom = withStyles({
    root: {
      color: theme.palette.primary.main,
    },
  })(CheckBoxIcon);

  return (
    <div>
      {!isLoading && (
        <>
          <div className={style.root}>
            <h1 className='md-title'>Events and Blockouts</h1>
          </div>

          <div className={style.root}>
              Staff name field
          </div>
          <div>
            <FormControlLabel control={
            <CheckBoxCustom
              checked={!!staffRequiredCreateBlockout}
              onChange={(evt, isChecked) => {
                setStaffRequiredCreateBlockout(isChecked);
                handleChange(isChecked, staffRequiredCreateEvent, staffRequiredEditBlockout, staffRequiredEditEvent)
              }}
              icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
              checkedIcon={<CheckBoxIconCustom fontSize="large" />}
            />}
            label={<span className={style.labelStyle}>Mandatory when creating a blockout</span>}/>
          </div>

          <div>
            <FormControlLabel control={
              <CheckBoxCustom
                checked={!!staffRequiredCreateEvent}
                onChange={(evt, isChecked) => {
                  setStaffRequiredCreateEvent(isChecked);
                  handleChange(staffRequiredCreateBlockout, isChecked, staffRequiredEditBlockout, staffRequiredEditEvent)
                }}
                icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
                checkedIcon={<CheckBoxIconCustom fontSize="large" />}
              />}
              label={<span className={style.labelStyle}>Mandatory when creating an event/function</span>}/>
          </div>

          <div>
            <FormControlLabel control={
              <CheckBoxCustom
                checked={!!staffRequiredEditEvent}
                icon={<CheckBoxOutlineBlankIcon fontSize="default" />}
                onChange={(evt, isChecked) => {
                  setStaffRequiredEditEvent(isChecked);
                  handleChange(staffRequiredCreateBlockout, staffRequiredCreateEvent, staffRequiredEditBlockout, isChecked)
                }}
                checkedIcon={<CheckBoxIconCustom fontSize="default" color="secondary"/>}
              />}
              label={<span className={style.labelStyle}>Mandatory when editing an event</span>}/>
          </div>

          <div>
            <FormControlLabel control={
              <CheckBoxCustom
                checked={!!staffRequiredEditBlockout}
                icon={<CheckBoxOutlineBlankIcon fontSize="default" />}
                onChange={(evt, isChecked) => {
                  setStaffRequiredEditBlockout(isChecked);
                  handleChange(staffRequiredCreateBlockout, staffRequiredCreateEvent, isChecked, staffRequiredEditEvent)
                }}
                checkedIcon={<CheckBoxIconCustom fontSize="default" color="secondary"/>}
              />}
             label={<span className={style.labelStyle}>Mandatory when editing a blockout</span>}/>
          </div>
        </>
      )}
    </div>
  )
}

